export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var ua = window.navigator.userAgent;
export const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
var webkit = !!ua.match(/WebKit/i);
export const  iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
console.log('is safari', isSafari)